import { render } from "./VotesTable.vue?vue&type=template&id=0f18fe68&scoped=true"
import script from "./VotesTable.vue?vue&type=script&lang=js"
export * from "./VotesTable.vue?vue&type=script&lang=js"

import "./VotesTable.vue?vue&type=style&index=0&id=0f18fe68&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0f18fe68"

export default script